import footerCopyright from './footer-copyright/footer-copyright';
import footerNavigation from './footer-navigation/footer-navigation';
import eventBus from '../../common/js/event-bus/event-bus';
export default {
	data() {
		return {
			ariaHide: false
		};
	},
	mounted() {
		eventBus.$on('toggleAriaHidden', (hide) => {
			this.ariaHide = hide;
		});
	},
	components: {
		footerCopyright,
		footerNavigation
	}
};
